import React, { useContext } from 'react'
import CatalogSearch from '@Components/Search/CatalogSearch'
import CatalogCompactWorkItem from '@Components/WorkItemV2/Catalog/CatalogCompactWorkItem'
import CatalogExtendedWorkItem from '@Components/WorkItemV2/Catalog/CatalogExtendedWorkItem'
import { StoresContext } from '@App/contexts'
import './index.scss'
import ExportTogglesForm from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/VerifyWorksStep/ExportTogglesForm'
import CatalogTransferWizardHeader from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/CatalogTransferWizardHeader'

const VerifyWorksStep = () => {
    const { userStore, transferCatalogSearchStore, catalogTransferWizardStore } = useContext(StoresContext)

    return (
        <div className="verify-works-step ct-wizard-step-container">
            <CatalogTransferWizardHeader title="Select Works">
                <p>
                    Please review and select the works you want to export. Click 'Select All Works' to select all of the
                    works registered to the Publisher you selected, or use the additional search fields to narrow the
                    list of works you wish to select and click 'Select Specific Works' to select only those works.
                </p>
            </CatalogTransferWizardHeader>
            <section className="verify-works-content">
                <ExportTogglesForm
                    transferCatalogSearchStore={transferCatalogSearchStore}
                    catalogTransferStore={catalogTransferWizardStore}
                    onValueChange={(exportCurrentSearch) =>
                        catalogTransferWizardStore.setExportCurrentSearch(exportCurrentSearch)
                    }
                    currentValue={catalogTransferWizardStore.exportCurrentSearch}
                />
                <CatalogSearch
                    userStore={userStore}
                    catalogSearchStore={transferCatalogSearchStore}
                    disableAutoComplete
                    compactWorkComponentType={CatalogCompactWorkItem}
                    extendedWorkComponentType={CatalogExtendedWorkItem}
                />
            </section>
        </div>
    )
}

export default VerifyWorksStep
